module.exports = __webpack_public_path__ + "img/loading.79c8818.svg";